import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    regionCountryChannel = new Subject();
    regionProvinceChannel = new Subject();
    regionCityChannel = new Subject();
    identityProvinceChannel = new Subject();
    identityCityChannel = new Subject();
    identityDistrictChannel = new Subject();
    identityVillageChannel = new Subject();
    detailChannel = new Subject();
    updateChannel = new Subject();
    repository = new UpdateRepository()

    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
    }

    fetchRegionCountry = async (query) => {
        this.regionCountryChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCountry(query).then((result) => {
            this.regionCountryChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCountryChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionProvince = async (query) => {
        this.regionProvinceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionProvince(query).then((result) => {
            this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionCity = async (query) => {
        this.regionCityChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCity(query).then((result) => {
            this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchIdentityProvince = async (query) => {
        this.identityProvinceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchIdentityProvince(query).then((result) => {
            this.identityProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.identityProvinceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchIdentityCity = async (query) => {
        this.identityCityChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchIdentityCity(query).then((result) => {
            this.identityCityChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.identityCityChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchIdentityDistrict = async (query) => {
        this.identityDistrictChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchIdentityDistrict(query).then((result) => {
            this.identityDistrictChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.identityDistrictChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchIdentityVillage = async (query) => {
        this.identityVillageChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchIdentityVillage(query).then((result) => {
            this.identityVillageChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.identityVillageChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUpdate(query).then((result) => {
            this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.updateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default UpdateBloc